import { Injectable } from '@angular/core';
import { ApiRouteConfig } from '../../config/api.route.config';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {ApplicationError} from './model/application-error';
import {noop} from 'rxjs';
import {HttpHeadersService} from './services/http-headers.service';

@Injectable()
export class ErrorLogService {
  constructor(private httpClient: HttpClient, private routes: ApiRouteConfig, private headersService: HttpHeadersService) {}

  public sendError(error: ApplicationError) {
    const headers = this.headersService.addNoLogHeader(new HttpHeaders());
    this.httpClient.post(this.routes.ERROR_HANDLER, error, {headers: headers}).subscribe(noop);
  }
}
